export default {
  workOrder: state => state.workOrder,
  technicians: state => state.technicians
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenance/getters.js